import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/_externalProjectionsLayout/dashboards/edit/$id/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      (!!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CUSTOM_DASHBOARDS }) ||
        !!context.userPermissions.hasAllowedPermission({
          path: PAGE_PATHS.CUSTOM_DASHBOARDS,
          permission: Permission.UPDATE,
        })) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
